import React from 'react';

import { NODE_TYPE as NT, } from 'shared/constants/slate';
import { BASE_COLOR as BC, } from 'shared/constants/colors';
import { classes as cn, uneditable } from 'shared/styles';
import { cx, styled, opacify, darken } from 'helpers';
import { Squiggly } from 'components/elems';


const softBlue = opacify(-0.3, BC.caretBlue);
const softerBlue = opacify(-0.7, BC.caretBlue);
const softWashedRed = opacify(-0.75, BC.washedRed);
const darkerRed = darken(0.2, BC.darkRed);

const highlightWhenSelected = props => {
  const { isSelected, thickness = 4 } = props;

  return {
    transition: 'all 50ms',
    boxShadow: isSelected
      ? `0 0 0 ${thickness}px ${softBlue}`
      : 'none',

    '&:hover': {
      boxShadow: isSelected
        ? `0 0 0 ${thickness}px ${softBlue}`
        : `0 0 0 ${thickness}px ${softerBlue}`,
    }
  };
};


const Selectible = styled('div')(highlightWhenSelected);

const MediaLoading = ({ className, ...props }) => (
  <Selectible
    className={cx("-flex-cc", className)}
    thickness={2}
    {...props}
  >
    <Squiggly style={{ width: '48px' }} />
  </Selectible>
);

const MessageFrame = ({children, className, style, ...rest}) => (
  <div
    {...uneditable}
    className={cx(
      "-abs-fill flex items-center ph2",
      "light-silver f5",
      className,
    )}
    style={style}
    {...rest}
  >
    {children}
  </div>
);

const ActionFrame = ({children, style}) => (
  <div
    {...uneditable}
    className={cx(
      "f5 light-silver pointer",
      "absolute right-0 top-0 bottom-0 flex",
    )}
    style={style}
  >
    {children}
  </div>
);



class FetchErrored extends React.Component {
  constructor(props) {
    super(props);
    this.turnIntoParagraph = this.turnIntoParagraph.bind(this);
  }

  turnIntoParagraph = () => {
    // Use setTimeout at 0 trick here, otherwise onChange seems to
    // fire first then gets overriden by Slate default onClick
    // handler with previous Slate value, resulting in the change
    // being undone..
    setTimeout(() => {
      const { editor, node } = this.props;
      const { value } = editor;
      const change = value.change();

      change
        .setNodeByKey(node.key, NT.default)
        .focus()

      return editor.onChange(change)
    }, 0);  // o_O
  }

  render() {
    const {
      attributes: attrs,
      children,
      isSelected,
      message,
    } = this.props;

    return (
      <Selectible
        className="relative ph2" {...attrs}
        style={{ background: softWashedRed }}
        isSelected={isSelected}
        thickness={2}
        onClick={this.turnIntoParagraph}
      >
        <div>{children}</div>

        <MessageFrame
          style={{ color: darkerRed }}
          className="pointer"
        >
          {message}
        </MessageFrame>

        <ActionFrame>
          <div
            className={cx(
              "flex items-center ph2",
              "hover-dark-gray",
              cn.animateFadeInSlow
            )}
          >
            Dismiss
          </div>
        </ActionFrame>
      </Selectible>
    );
  }
}



export {
  highlightWhenSelected,
  Selectible,
  MessageFrame,
  ActionFrame,
  MediaLoading,

  FetchErrored,
}



// WEBPACK FOOTER //
// ./src/components/slate/nodes/extra.js